export interface HistorischeFolderOption {
  kind: "ordner" | "sordner";
  id: number;
  label: string;
  description?: string;
  kundeId: number | null;
}

export function filterHistorischeFolderOptions(
  folders: HistorischeFolderOption[],
  options: { query: string; kundenId: number | null; limit?: number },
): HistorischeFolderOption[] {
  const q = options.query.trim().toLowerCase();
  let pool = folders;
  if (options.kundenId) {
    const matched = folders.filter((folder) => folder.kundeId === options.kundenId);
    if (matched.length > 0) pool = matched;
  }
  const filtered = q
    ? pool.filter((folder) =>
        `${folder.label} ${folder.description ?? ""}`.toLowerCase().includes(q),
      )
    : pool;
  return filtered.slice(0, options.limit ?? 30);
}

export function historischePositionenScopeHint(parts: {
  kunde?: string | null;
  ansprechpartner?: string | null;
  ordner?: string | null;
}): string {
  const active = [
    parts.kunde ? `Kunde ${parts.kunde}` : null,
    parts.ansprechpartner ? `Ansprechpartner ${parts.ansprechpartner}` : null,
    parts.ordner ? `Ordner ${parts.ordner}` : null,
  ].filter((part): part is string => Boolean(part));
  if (active.length === 0) {
    return "Suche über alle Kunden, Ansprechpartner und Ordner.";
  }
  return `Eingeschränkt auf ${active.join(", ")}.`;
}
